import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SectionTitle from "../../components/common/SectionTitle/SectionTitle";
import "./TermsConditionsPage.css";

export default function TermsConditionsPage() {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy-page">
      <Container>
        <div className="section-spacing">
          <SectionTitle subtitle={t("terms.subtitle")} title={t("terms.title")} />
        </div>

        <p className="reg-text">
          <strong>{t("terms.lastUpdated")}</strong>
        </p>

        <p className="reg-text">{t("terms.intro1")}</p>
        <p className="reg-text mb-4">{t("terms.intro2")}</p>

        <h5 className="reg-title">{t("terms.s1.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s1.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s1.list1")}</p></li>
          <li><p>{t("terms.s1.list2")}</p></li>
          <li><p>{t("terms.s1.list3")}</p></li>
          <li><p>{t("terms.s1.list4")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s1.content2")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s1.list5")}</p></li>
          <li><p>{t("terms.s1.list6")}</p></li>
          <li><p>{t("terms.s1.list7")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s1.content3")}</p>

        <h5 className="reg-title">{t("terms.s2.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s2.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s2.list1")}</p></li>
          <li><p>{t("terms.s2.list2")}</p></li>
          <li><p>{t("terms.s2.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s2.content2")}</p>

        <h5 className="reg-title">{t("terms.s3.title")}</h5>
        <p className="reg-text">{t("terms.s3.content1")}</p>
        <p className="reg-text">{t("terms.s3.content2")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s3.list1")}</p></li>
          <li><p>{t("terms.s3.list2")}</p></li>
          <li><p>{t("terms.s3.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s3.content3")}</p>

        <h5 className="reg-title">{t("terms.s4.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s4.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s4.list1")}</p></li>
          <li><p>{t("terms.s4.list2")}</p></li>
          <li><p>{t("terms.s4.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s4.content2")}</p>

        <h5 className="reg-title">{t("terms.s5.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s5.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s5.list1")}</p></li>
          <li><p>{t("terms.s5.list2")}</p></li>
          <li><p>{t("terms.s5.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s5.content2")}</p>

        <h5 className="reg-title">{t("terms.s6.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s6.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s6.list1")}</p></li>
          <li><p>{t("terms.s6.list2")}</p></li>
          <li><p>{t("terms.s6.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s6.content2")}</p>

        <h5 className="reg-title">{t("terms.s7.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s7.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s7.list1")}</p></li>
          <li><p>{t("terms.s7.list2")}</p></li>
          <li><p>{t("terms.s7.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s7.content2")}</p>

        <h5 className="reg-title">{t("terms.s8.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s8.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s8.list1")}</p></li>
          <li><p>{t("terms.s8.list2")}</p></li>
        </ul>

        <h5 className="reg-title">{t("terms.s9.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s9.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s9.list1")}</p></li>
          <li><p>{t("terms.s9.list2")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s9.content2")}</p>

        <h5 className="reg-title">{t("terms.s10.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s10.content")}</p>

        <h5 className="reg-title">{t("terms.s11.title")}</h5>
        <p className="reg-text mb-4">{t("terms.s11.content1")}</p>
        <ul className="reg-list">
          <li><p>{t("terms.s11.list1")}</p></li>
          <li><p>{t("terms.s11.list2")}</p></li>
          <li><p>{t("terms.s11.list3")}</p></li>
        </ul>
        <p className="reg-text mb-4">{t("terms.s11.content2")}</p>
      </Container>
    </div>
  );
}